import { DeathProductBackend } from "Components/Features/CheckPrice/Products/Advice/mappers/mapToCommerceDeath";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { MappingData } from "./mapToCartProducts";

export const mapToDeathProduct = (data: MappingData): DeathProductBackend => {
  return {
    name: INSURANCE_NAME_VALUE.DEATH,
    coverageGroup: data.priceData[0].configurationName,
    dateOfBirth: data.customerData.newCustomerResponse.dateOfBirth ?? "",
    insuredSum: data.priceFormData.deathInsuredSumSlider ?? 0,
    isFemale: data.customerData.newCustomerResponse.isFemale,
    isScandinavianCitizen: true,
    isSmoker: false,
    isStayingInNorwayForMoreThanFiveYears: true,
  };
};
